import { render, staticRenderFns } from "./form-contatti.vue?vue&type=template&id=77316ef5&scoped=true"
import script from "./form-contatti.vue?vue&type=script&lang=js"
export * from "./form-contatti.vue?vue&type=script&lang=js"
import style0 from "./form-contatti.vue?vue&type=style&index=0&id=77316ef5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77316ef5",
  null
  
)

export default component.exports